import React from 'react';

interface TargetCardProps {
  icon: string;
  title: string;
  description: string;
}

const TargetCard: React.FC<TargetCardProps> = ({ icon, title, description }) => {
  return (
    <div className="card-target">
      <div className="card-target-icon-wrapper">
        <img src={icon} alt="Service Icon" className="icon" />
      </div>

      <div className="card-target-content">
        <h3 className="card-target-title">{title}</h3>
        <p className="card-target-description">{description}</p>
      </div>
    </div>
  );
};

export default TargetCard;
